import { render, staticRenderFns } from "./orderCreateYC.vue?vue&type=template&id=5b88fff4&scoped=true"
import script from "./orderCreateYC.vue?vue&type=script&lang=js"
export * from "./orderCreateYC.vue?vue&type=script&lang=js"
import style0 from "./orderCreateYC.vue?vue&type=style&index=0&id=5b88fff4&prod&lang=css"
import style1 from "./orderCreateYC.vue?vue&type=style&index=1&id=5b88fff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88fff4",
  null
  
)

export default component.exports